export default __webpack_public_path__ + "img/Inter-ExtraLightItalic_e7ecb03.woff2";